import React from 'react'
import Login from './Login'
import Header from './Header'

const HeaderLayout = () => {
  return (
    <div>
      <Header AuthModalsComponent={<Login />} />
    </div>
  )
}

export default HeaderLayout